export default {
	"components.MakeAnOnlinePayment": "进行在线付款",
	"components.ClickOnTheUpperRightCornerOfTheScreen": "点击屏幕右上角",
	"components.SelectABrowserToOpenThisPage": "，选择浏览器打开本页"
}